/*
 * @Descripttion:
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-05 20:23:32
 * @LastEditors: ???
 * @LastEditTime: 2022-05-19 20:39:27
 */
import request from '@/utils/request';

// 街道id获取社区
export function getCommunityDataByStreetId(data) {
  return request({
    url: '/community/statistical/community/bookingOrder',
    method: 'post',
    data,
  });
}
// 街道
export function getStreetList(params) {
  return request({
    url: `/address/street/list`,
    method: 'get',
    params,
  });
}

// 上方统计
export function getOrderAmountSummary(data) {
  return request({
    url: `/community/statistical/community/bookingSummary`,
    method: 'post',
    data,
  });
}
// 街道id获取社区
export function getCommunityCompleteDataByStreetId(data) {
  return request({
    url: '/community/statistical/community/compleOrder',
    method: 'post',
    data,
  });
}
// 上方统计
export function getCompleteAmountSummary(data) {
  return request({
    url: `/community/statistical/compleOrderSummary`,
    method: 'post',
    data,
  });
}
